import { Navigate, useLocation } from "react-router-dom";
import { REDIRECTS } from "@/data/redirects";

export default function OldUrlRedirect() {
    const location = useLocation();

    let key = location.pathname.toLowerCase();
    try {
        key = decodeURIComponent(location.pathname).toLowerCase();
    } catch {
        key = location.pathname.toLowerCase();
    }

    const target = REDIRECTS[key] ?? REDIRECTS[location.pathname.toLowerCase()];
    if (!target) return null;

    if (typeof target === "string") return <Navigate to={target} replace />;
    if (target.scrollTo) {
        try {
            sessionStorage.setItem("scroll_to", target.scrollTo);
        } catch {
            /* ignore */
        }
    }
    return <Navigate to={target.to} replace />;
}
